import Vue from 'vue'
import Router from 'vue-router'
import {routers} from '../pages'

function initRouter () {
  let values = Object.keys(routers)
  let list = []
  let isInited
  values.forEach((key) => {
    if (!isInited) {
      isInited = true
      list.push({path: '/', redirect: '/' + key})
    }
    list.push({path: '/' + key + '/:id?/:sub?', name: key, component: routers[key]})
  })
  return list
}

Vue.use(Router)

export default new Router({
  routes: initRouter()
})



// WEBPACK FOOTER //
// ./src/router/index.js